import { IFormActualsTargetsSettings } from 'legacy/lut/classes/models/partner360/IFormActualsTargetsSettings'
import { ITranslationFactors } from 'legacy/lut/classes/models/partner360/ITranslationFactors'
import { IJBPMAP } from 'legacy/lut/components/widgets/public/partner360/models/IJBPPMAP'

import { IJBPPlanning } from './IJBPPlanning'

export interface IGetPlanningParams {
  partnerId: string
  fYear: number
  fromFYear: number
  /** `null` asks for every offering's rows. */
  programType: string | null
  isRegionalDistributor: boolean
}

/** SMB vs EU split row returned in `planningGzip.data.PlanningSMB`. */
export interface IPlanningSmb {
  EntryId?: number
  UID?: string
  Created?: string
  CreatedBy?: string
  Modified?: string
  ModifiedBy?: string
  PartnerID: string
  FYear: number
  ProgramType: string
  Category: string
  SubCategory: string
  L3Category: string | null
  /** `1`–`4` are fiscal quarters; `5` is the whole fiscal year. */
  FQuarter: number
  SMBPercent: number
  EUPercent: number
  IsCollapsed?: number | null
  IsDisabled?: number | null
}

export interface IPlanningData {
  Settings: IFormActualsTargetsSettings[]
  Planning: IJBPPlanning[]
  /** SMB vs EU split entered on top of the plan. */
  PlanningSMB: IPlanningSmb[]
  Map: IJBPMAP[]
  TranslationFactors: ITranslationFactors[]
  AdditionalInfo?: IAdditionalInfoItem[]
}

export interface IPlanningGzipResponse {
  status: string
  data: IPlanningData
}

export interface IAdditionalInfoItem {
  [key: string]: string
}

export enum AdditionalInfoKeys {
  PolyPlanningLevel = 'PolyPlanningLevel',
}

export type TPolyPlanningLevel = 'Category' | 'SubCategory'
